import { useTranslation } from 'react-i18next'

import LanguageToggle from '~/components/LanguageToggle'
import PageTitle from '~/components/PageTitle'
import Svg from '~/components/svg'
import { useAppInfo } from '~/hooks/useAppInfo'

import ForgotPasswordForm from '../../components/ForgotPasswordForm'
// import ForgotPasswordImage from '../../components/ForgotPasswordImage'

import * as S from './styles'

const ForgotPassword = () => {
  const { t } = useTranslation()
  /**
   * Handle app info
   */
  const { logo: urlLogo, name } = useAppInfo()

  /**
   * END = Handle app info
   */

  return (
    <S.Container className="m-auto px-5 bg-white border rounded-3">
      <PageTitle title={t('auth:forgotPassword.pageTitle')} />

      <header>
        {urlLogo ? (
          <img
            src={urlLogo}
            alt={name}
            className="object-fit-contain"
            width="auto"
            height="28"
            style={{ marginBottom: '1.5rem' }}
          />
        ) : (
          <Svg
            src="brands/logo-vtex-ads"
            width="auto"
            height="28"
            style={{ width: 'auto', marginBottom: '1.5rem' }}
          />
        )}

        <div>
          <h3>{t('auth:forgotPassword.header.title')}</h3>
          <p>{t('auth:forgotPassword.header.subtitle')}</p>
        </div>
      </header>

      <ForgotPasswordForm />

      <footer>
        <LanguageToggle />
      </footer>
      {/* <ForgotPasswordImage /> */}
    </S.Container>
  )
}

export default ForgotPassword
